var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2333_264677",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2333_264677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 13.334C11.0418 13.334 11.9272 12.9694 12.6564 12.2402C13.3856 11.5111 13.7502 10.6257 13.7502 9.58398C13.7502 8.54232 13.3856 7.6569 12.6564 6.92773C11.9272 6.19857 11.0418 5.83398 10.0002 5.83398C8.9585 5.83398 8.07308 6.19857 7.34391 6.92773C6.61475 7.6569 6.25016 8.54232 6.25016 9.58398C6.25016 10.6257 6.61475 11.5111 7.34391 12.2402C8.07308 12.9694 8.9585 13.334 10.0002 13.334ZM10.0002 11.834C9.37516 11.834 8.84391 11.6152 8.40641 11.1777C7.96891 10.7402 7.75016 10.209 7.75016 9.58398C7.75016 8.95898 7.96891 8.42773 8.40641 7.99023C8.84391 7.55273 9.37516 7.33398 10.0002 7.33398C10.6252 7.33398 11.1564 7.55273 11.5939 7.99023C12.0314 8.42773 12.2502 8.95898 12.2502 9.58398C12.2502 10.209 12.0314 10.7402 11.5939 11.1777C11.1564 11.6152 10.6252 11.834 10.0002 11.834ZM10.0002 15.834C7.97239 15.834 6.12516 15.268 4.4585 14.1361C2.79183 13.0041 1.5835 11.4868 0.833496 9.58398C1.5835 7.68121 2.79183 6.16385 4.4585 5.0319C6.12516 3.89996 7.97239 3.33398 10.0002 3.33398C12.0279 3.33398 13.8752 3.89996 15.5418 5.0319C17.2085 6.16385 18.4168 7.68121 19.1668 9.58398C18.4168 11.4868 17.2085 13.0041 15.5418 14.1361C13.8752 15.268 12.0279 15.834 10.0002 15.834Z",
    fill: "#DDDDDD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEye);
export default __webpack_public_path__ + "static/media/icEye.f0f2ec522b94fc269bf0509543308265.svg";
export { ForwardRef as ReactComponent };